require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-stand-up-meeting.json") })
        }
      }, "path---workshops-stand-up-meeting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-stand-up-meeting!./.cache/json/workshops-stand-up-meeting.json
// module id = 513
// module chunks = 231608221292675